import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import ProductDescription from './product/ProductDescription';
import Typography from '../../layouts/theme-onboarding/Typography';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useDispatch } from 'react-redux';
import { showAlert } from '../../redux/create-actions/AlertAction';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormLabel from '@mui/material/FormLabel';
import data from '../../config/producttype.json';
import { initStep2Data } from '../../utils/object/Signup';
import AddCardIcon from '@mui/icons-material/AddCard';
import Stack from '@mui/material/Stack';
import { filterProductByProductType } from '../../utils/function/Function';
import Color from '../../layouts/Color';
import { graphGetAllProducts } from '../../services/Onboarding';

const info = { textAlign: 'left' };
const groupRadio = { alignSelf: 'flex-start' };
const container = { mt: 1 };
const iconColor = { color: Color.Main };
const minStyle = { minWidth: 120 }

export default function Product(props) {
  const [productType, setProductType] = useState(1);
  const [product, setProduct] = useState('');
  const [listProducts, setListProducts] = useState([]);
  const [filterProducts, setFilterProducts] = useState([]);
  const dispatch = useDispatch();

  const filterProductByProductCode = (code) => {
    return filterProducts.filter(product => product.productCode === code);
  }

  useEffect(() => {
    let alert = {
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'center'
      },
      isOpen: true,
      severity: 'error',
      title: 'Error',
      message: '',
    };

    const variables = {
      "filter": {
        "isDelete": 0
      },
      "options": {
        "fetchAll": true
      }
    }

    let promise = graphGetAllProducts(variables);
    promise.then(result => {
      let list = filterProductByProductType(result.items, "PREPAID");
      setListProducts(result.items);
      setFilterProducts(list);

    }).catch(function (error) {
      const err = JSON.parse(JSON.stringify(error))
      alert = { ...alert, message: err.response.errors[0].message };
      dispatch(showAlert(alert));
    });
  }, [dispatch]);

  const renderProductOption = filterProducts.map((item, i) => {
    return (
      <MenuItem value={item.productCode} key={i}>{item.name}</MenuItem>
    );
  });

  const renderProductType = data.types.map((item, i) => {
    return (
      <FormControlLabel value={item.value} control={<Radio />} label={item.label} key={i} />
    );
  });

  const handleChangeProductType = (event) => {
    let value = parseInt(event.target.value);
    let list;
    switch (value) {
      case 1:
        list = filterProductByProductType(listProducts, "PREPAID");
        break;
      case 2:
        list = filterProductByProductType(listProducts, "CREDIT");
        break;
      default:
        list = [];
        break;
    }
    setProductType(value);
    setFilterProducts(list);
    setProduct('');
    props.onUpdateStep2Data(initStep2Data(value, '', null));
  }

  const handleChangeProduct = (event) => {
    let value = event.target.value;
    setProduct(value);
    let currentProduct = filterProductByProductCode(value);
    props.onUpdateStep2Data(initStep2Data(productType, value, currentProduct[0].name));
  };

  return (
    <React.Fragment>
      <Stack direction="row" justifyContent="center" spacing={1}>
        <Typography variant="h6" marked="left" gutterBottom color={Color.Main}> Product</Typography>
        <AddCardIcon sx={iconColor}></AddCardIcon>
      </Stack>
      <Grid container spacing={3} sx={container}>
        <Grid item xs={12} sx={info}>
          <Typography variant="subtitle1" color={Color.Main}> Please select product type and product: </Typography>
        </Grid>
        <Grid item xs={12}>
          <FormControl fullWidth>
            <FormLabel id="demo-row-radio-buttons-group-label" sx={groupRadio}>Product Type:</FormLabel>
            <RadioGroup
              row
              aria-labelledby="demo-row-radio-buttons-group-label"
              name="row-radio-buttons-group"
              value={productType}
              onChange={handleChangeProductType}
            >
              {renderProductType}
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <FormControl sx={minStyle} fullWidth>
            <InputLabel id="demo-simple-select-helper-label">Product *</InputLabel>
            <Select
              labelId="demo-simple-select-helper-label"
              id="demo-simple-select-helper"
              value={product}
              label="Product"
              onChange={handleChangeProduct}
            >
              {renderProductOption}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} sm={6}>
          <ProductDescription selectedProduct={product} ></ProductDescription>
        </Grid>
      </Grid>
    </React.Fragment>
  );
}